// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ua-grid-center-top-container {
    width: 100%;
    height: 400px;
    margin-top: -70px;  
}

  /* Cover Photo */
  .uac-cover-container {
    position: relative;
    height: 250px;
    width: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
  }
  
  .uac-profile-photo {
    position: absolute;
    bottom: -30px;
    left: 20px;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: bold;
  }
  
  .uac-feed-navigation {
    position: relative;
    height: 80px;
    width: 100%;                /* full width of parent */
    display: flex;
    flex-direction: row;
    align-items: center;
    border-radius: 10px;
    margin-top: 0;
    box-sizing: border-box;      /* ensure padding/borders don't break layout */
  }
  
    .uac-feed-navigation-first {
      position: relative;
      height: 70px;
      flex: 0 0 70%;               /* fixed 80% width */
      max-width: 70%;
      background: none;
      display: flex;
      border-radius: 10px;
      margin-left: 0;              /* reset */
      box-sizing: border-box;
    }

    .uac-feed-navigation-second {
      position: relative;
      height: 80px;
      flex: 0 0 25%;               /* fixed 20% width */
      max-width: 25%;
      display: flex;
      justify-content: flex-end;   /* push content to right */
      align-items: center;         /* vertically center */
      border-radius: 10px;
      margin-top: 0px;               /* reset */
      box-sizing: border-box;
    }

    .uacf-post-container {
      position: relative;
      height: 330px;
      width: 800px;
      background-color: rgb(34, 31, 31);
      display: flex;
      /* align-items: center; */
      justify-content: center;
      border-radius: 10px;
      margin: 30px auto 0 auto;  /* Vertical 30px top margin, auto horizontal */
      /* box-shadow: 0px 4px 6px gray; */
    }

    /* .uacf-post-container:hover {
      box-shadow: 1px 1px 1px white;
    } */

  .uac-feed-navigation button {
    background-color: white;
    width: 130px;
    margin-top: 15px;
    color: black;
    border: black;
    padding: 10px 15px;
    border-radius: 30px;
    cursor: pointer;
  }

  .uac-expandable-button {
    margin-left: 30px;
    background-color: none;
    background: none;
    border: black;
    width: 170px;
    font-size: 16px;
    border-radius: 5px;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    border: 1px solid black;
  }
  
  .uac-expandable-button:hover {
    width: 130px;
    box-shadow: 0 0 5px green;
  }

  .uac-post-options {
    position: relative;
    display: inline-block;
  }
  
  .uac-more-options-btn {
    background: rgb(245, 238, 238);
    margin-top: 20px;
    margin-left: 170px;
    width: 50px;
    background: none;
    border: none;
    font-size: 20px;
    cursor: pointer;
  }
  
  .uac-dropdown-menu {
    position: absolute;
    margin-right: -150px;
    top: 30px;
    right: 0;
    background: rgb(245, 238, 238);
    border: 1px solid #ddd;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    overflow: hidden;
    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    font-size: 18px;
  }
  
  .uac-dropdown-menu button {
    width: 100%;
    padding: 10px;
    border: none;
    background: rgb(245, 238, 238);
    cursor: pointer;
    text-align: left;
  }
  
  .uac-dropdown-menu button:hover {
    background: #f0f0f0;
  }

  .uac-post-container {
    width: 100%;
    height: 100%;
    border: 1px solid black;
    border-radius: 8px;
    background: none;    
    overflow-y: auto;
    padding: 30px;
    background: var(--card-bg, rgb(4, 4, 4));
    border: 1px solid var(--border-color, rgb(52, 51, 51));
  }

  .uacp-description-input {
    margin-left: 0px;
    height: 50%;
    width: 100%;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    resize: none;
    overflow-y: auto;
  }

  .uac-submission-container {
    height: auto;
    width: 100%;
    max-width: 1000px;
    max-height: 60px;
    padding: 15px;
    border: 1px solid #ddd;
    border-radius: 8px;
    background:rgb(245, 238, 238);
    /* box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1); */
    overflow-y: auto;
  }
  
  .uacp-media-section {
    /* margin-top: 60px;
    margin-bottom: 0px; */
    width: 10%;
    margin-left: 10px;
    height: -10px;
    display: flex;
    align-items: center;
    gap: 10px;
    background: black;
  }
  
  .uac-upload-btn, .uac-post-btn {
    padding: 8px 12px;
    margin-right: 5px;
    width: 30px;
    height: 30px;
    font-size: 12px;
    background: #007bff;
    color: white;
    border: none;
    cursor: pointer;
    border-radius: 5px;
  }

  .uacp-upload-btn {
    padding: 8px 12px;
    width: 150px;
    height: 30px;
    align-items: center;
    font-family: puppins;
    font-size: 15px;
    color:white;
    cursor: pointer;
    border-radius: 10px;
    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    border: "1px solid gray";
    margin-top: 10px;
  }
  
  .uacp-post-btn {
    padding: 8px 12px;
    width: 100px;
    height: 30px;
    align-items: center;
    font-family: puppins;
    font-size: 15px;
    margin-left: 20px;
    color: white;
    border: none;
    cursor: pointer;
    border-radius: 10px;
    border: "1px solid gray";
    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    margin-top: 10px;
  }
  
  .uac-uploaded-media {
    margin-top: 10px;
  }
  
  .uac-media-preview {
    display: inline-block;
    padding: 5px;
    margin: 3px;
    border-radius: 4px;
  }
  
  .uac-tab-button {
    padding: 10px 15px;
    border: none;
    color: black;
    cursor: pointer;
    transition: 0.3s;
  }
  
  .uac-active-tab {
    color: white !important;
    cursor: default; /* Make it non-clickable */
    font-weight: bold;
  }

  .uac-remove-btn {
    padding: 8px 12px;
    width: 65px;
    height: 30px;
    align-items: center;
    font-family: puppins;
    font-size: 12px;
    margin-left: 20px;
    color: white;
    border: "1px solid gray";
    cursor: pointer;
    border-radius: 10px;
    cursor: not-allowed; /* Show disabled cursor */
    opacity: 0.6;
    margin-top: 20px;
  }
  
  .uac-remove-btn:not(:disabled) {
    background-color: darkgray;
    color: black;
    cursor: pointer;
    opacity: 1;
  }

  /* Main Feed */
  .uac-main-feed {
    width: 100%;
    border-radius: 10px;
    height: 100px;        /* Fixed height */
    max-height: 1000vh;
  }

.uac-text-label {
  font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
  font-size: 20px;
  /* font-weight: lighter; */
}

/* ============================================================
   USER ACCOUNT CREATE POST - METADATA SECTION
   ============================================================ */

   .uac-metadata-container {
    margin-top: 10px;
    display: flex;
    align-items: center;
    gap: 25px;
    flex-wrap: wrap;
    padding: 15px;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 10px;
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    border: 1px solid rgba(255, 255, 255, 0.1);
  }
  
  .uac-visibility-section {
    display: flex;
    /* align-items: center; */
    gap: 10px;
  }
  
  .uac-metadata-label {
    font-weight: 600;
    color: rgba(255, 255, 255, 0.9);
    font-size: 14px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
  }
  
  .uac-visibility-status {
    font-weight: bold;
    font-size: 14px;
    padding: 4px 12px;
    border-radius: 12px;
    background: rgba(0, 0, 0, 0.3);
  }
  
  /* ============================================================
     ID FIELDS (USER ID & PROFILE ID)
     ============================================================ */
  
  .uac-id-field {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 15px;
    background: rgba(0, 0, 0, 0.3);
    border-radius: 8px;
    border: 1px solid rgba(255, 255, 255, 0.15);
    transition: all 0.3s ease;
    height: 45px;
  }
  
  .uac-id-field:hover {
    background: rgba(0, 0, 0, 0.4);
    border-color: rgba(102, 126, 234, 0.5);
  }
  
  .uac-id-value {
    font-weight: 700;
    color: rgba(255, 255, 255, 0.95);
    font-size: 13px;
    font-family: "Courier New", monospace;
    padding: 4px 10px;
    background: rgba(102, 126, 234, 0.2);
    border-radius: 6px;
    letter-spacing: 0.5px;
  }
  
  /* User ID - Missing State */
  .uac-id-missing {
    background: rgba(239, 68, 68, 0.3);
    color: rgba(239, 68, 68, 1);
    font-style: italic;
  }
  
  /* Profile ID - Optional State */
  .uac-id-optional {
    background: rgba(156, 163, 175, 0.2);
    color: rgba(209, 213, 219, 1);
  }
  
  /* ============================================================
     DISABLED STATE FOR POST CREATION
     ============================================================ */
  
  .uacp-description-input:disabled,
  .uacp-upload-btn:disabled,
  .uac-remove-btn:disabled,
  .uacp-post-btn:disabled {
    opacity: 0.4;
    cursor: not-allowed;
    filter: grayscale(70%);
  }
  
  .uac-metadata-container input:disabled ~ .up-toggle-slider {
    opacity: 0.5;
    cursor: not-allowed;
  }
  
  /* ============================================================
     RESPONSIVE DESIGN
     ============================================================ */
  
  @media screen and (max-width: 768px) {
    .uac-metadata-container {
      flex-direction: column;
      align-items: flex-start;
      gap: 15px;
      margin-left: 0;
      padding: 12px;
    }
  
    .uac-visibility-section {
      width: 100%;
      justify-content: space-between;
    }
  
    .uac-id-field {
      width: 100%;
      justify-content: space-between;
    }
  }
  
  @media screen and (max-width: 480px) {
    .uac-metadata-label {
      font-size: 12px;
    }
  
    .uac-id-value {
      font-size: 11px;
      padding: 3px 8px;
    }
  
    .uac-visibility-status {
      font-size: 12px;
      padding: 3px 10px;
    }
  }
  
  /* ============================================================
     ACCESSIBILITY
     ============================================================ */
  
  .uac-id-field:focus-within {
    outline: 2px solid rgba(102, 126, 234, 0.6);
    outline-offset: 2px;
  }
  
  @media (prefers-contrast: high) {
    .uac-id-field {
      border-width: 2px;
      border-color: currentColor;
    }
  
    .uac-metadata-container {
      border-width: 2px;
    }
  }
  
  @media (prefers-reduced-motion: reduce) {
    .uac-id-field {
      transition: none;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Pages/AccountPage/Styles/UserAccountGridCenter.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,iBAAiB;AACrB;;EAEE,gBAAgB;EAChB;IACE,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,UAAU;IACV,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,WAAW,iBAAiB,yBAAyB;IACrD,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,sBAAsB,OAAO,8CAA8C;EAC7E;;IAEE;MACE,kBAAkB;MAClB,YAAY;MACZ,aAAa,gBAAgB,oBAAoB;MACjD,cAAc;MACd,gBAAgB;MAChB,aAAa;MACb,mBAAmB;MACnB,cAAc,eAAe,UAAU;MACvC,sBAAsB;IACxB;;IAEA;MACE,kBAAkB;MAClB,YAAY;MACZ,aAAa,gBAAgB,oBAAoB;MACjD,cAAc;MACd,aAAa;MACb,yBAAyB,IAAI,0BAA0B;MACvD,mBAAmB,UAAU,sBAAsB;MACnD,mBAAmB;MACnB,eAAe,gBAAgB,UAAU;MACzC,sBAAsB;IACxB;;IAEA;MACE,kBAAkB;MAClB,aAAa;MACb,YAAY;MACZ,iCAAiC;MACjC,aAAa;MACb,yBAAyB;MACzB,uBAAuB;MACvB,mBAAmB;MACnB,wBAAwB,GAAG,8CAA8C;MACzE,kCAAkC;IACpC;;IAEA;;OAEG;;EAEL;IACE,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;IAChB,aAAa;IACb,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,gCAAgC;IAChC,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,8BAA8B;IAC9B,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,oBAAoB;IACpB,SAAS;IACT,QAAQ;IACR,8BAA8B;IAC9B,sBAAsB;IACtB,wCAAwC;IACxC,mBAAmB;IACnB,gBAAgB;IAChB,mJAAmJ;IACnJ,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,YAAY;IACZ,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,wCAAwC;IACxC,sDAAsD;EACxD;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,6BAA6B;IAC7B,gDAAgD;IAChD,gBAAgB;EAClB;;EAEA;IACE;yBACqB;IACrB,UAAU;IACV,iBAAiB;IACjB,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,oBAAoB;IACpB,eAAe;IACf,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,mJAAmJ;IACnJ,wBAAwB;IACxB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,YAAY;IACZ,YAAY;IAEZ,mBAAmB;IACnB,oBAAoB;IACpB,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,wBAAwB;IACxB,mJAAmJ;IACnJ,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;IACrB,YAAY;IACZ,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,eAAe,EAAE,0BAA0B;IAC3C,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,YAAY;IAEZ,mBAAmB;IACnB,oBAAoB;IACpB,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,wBAAwB;IACxB,eAAe;IACf,mBAAmB;IACnB,mBAAmB,EAAE,yBAAyB;IAC9C,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;IAC1B,YAAY;IACZ,eAAe;IACf,UAAU;EACZ;;EAEA,cAAc;EACd;IACE,WAAW;IACX,mBAAmB;IACnB,aAAa,SAAS,iBAAiB;IACvC,kBAAkB;EACpB;;AAEF;EACE,6EAA6E;EAC7E,eAAe;EACf,0BAA0B;AAC5B;;AAEA;;iEAEiE;;GAE9D;IACC,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,aAAa;IACb,qCAAqC;IACrC,mBAAmB;IACnB,0BAA0B;IAC1B,kCAAkC;IAClC,0CAA0C;EAC5C;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,+BAA+B;IAC/B,eAAe;IACf,yBAAyB;IACzB,qBAAqB;IACrB,6EAA6E;EAC/E;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;;mEAEiE;;EAEjE;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,8BAA8B;IAC9B,kBAAkB;IAClB,2CAA2C;IAC3C,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,8BAA8B;IAC9B,sCAAsC;EACxC;;EAEA;IACE,gBAAgB;IAChB,gCAAgC;IAChC,eAAe;IACf,qCAAqC;IACrC,iBAAiB;IACjB,oCAAoC;IACpC,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA,4BAA4B;EAC5B;IACE,kCAAkC;IAClC,2BAA2B;IAC3B,kBAAkB;EACpB;;EAEA,gCAAgC;EAChC;IACE,oCAAoC;IACpC,6BAA6B;EAC/B;;EAEA;;mEAEiE;;EAEjE;;;;IAIE,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;;mEAEiE;;EAEjE;IACE;MACE,sBAAsB;MACtB,uBAAuB;MACvB,SAAS;MACT,cAAc;MACd,aAAa;IACf;;IAEA;MACE,WAAW;MACX,8BAA8B;IAChC;;IAEA;MACE,WAAW;MACX,8BAA8B;IAChC;EACF;;EAEA;IACE;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;MACf,gBAAgB;IAClB;;IAEA;MACE,eAAe;MACf,iBAAiB;IACnB;EACF;;EAEA;;mEAEiE;;EAEjE;IACE,2CAA2C;IAC3C,mBAAmB;EACrB;;EAEA;IACE;MACE,iBAAiB;MACjB,0BAA0B;IAC5B;;IAEA;MACE,iBAAiB;IACnB;EACF;;EAEA;IACE;MACE,gBAAgB;IAClB;EACF","sourcesContent":[".ua-grid-center-top-container {\n    width: 100%;\n    height: 400px;\n    margin-top: -70px;  \n}\n\n  /* Cover Photo */\n  .uac-cover-container {\n    position: relative;\n    height: 250px;\n    width: 400px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 10px;\n  }\n  \n  .uac-profile-photo {\n    position: absolute;\n    bottom: -30px;\n    left: 20px;\n    width: 80px;\n    height: 80px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 14px;\n    font-weight: bold;\n  }\n  \n  .uac-feed-navigation {\n    position: relative;\n    height: 80px;\n    width: 100%;                /* full width of parent */\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    border-radius: 10px;\n    margin-top: 0;\n    box-sizing: border-box;      /* ensure padding/borders don't break layout */\n  }\n  \n    .uac-feed-navigation-first {\n      position: relative;\n      height: 70px;\n      flex: 0 0 70%;               /* fixed 80% width */\n      max-width: 70%;\n      background: none;\n      display: flex;\n      border-radius: 10px;\n      margin-left: 0;              /* reset */\n      box-sizing: border-box;\n    }\n\n    .uac-feed-navigation-second {\n      position: relative;\n      height: 80px;\n      flex: 0 0 25%;               /* fixed 20% width */\n      max-width: 25%;\n      display: flex;\n      justify-content: flex-end;   /* push content to right */\n      align-items: center;         /* vertically center */\n      border-radius: 10px;\n      margin-top: 0px;               /* reset */\n      box-sizing: border-box;\n    }\n\n    .uacf-post-container {\n      position: relative;\n      height: 330px;\n      width: 800px;\n      background-color: rgb(34, 31, 31);\n      display: flex;\n      /* align-items: center; */\n      justify-content: center;\n      border-radius: 10px;\n      margin: 30px auto 0 auto;  /* Vertical 30px top margin, auto horizontal */\n      /* box-shadow: 0px 4px 6px gray; */\n    }\n\n    /* .uacf-post-container:hover {\n      box-shadow: 1px 1px 1px white;\n    } */\n\n  .uac-feed-navigation button {\n    background-color: white;\n    width: 130px;\n    margin-top: 15px;\n    color: black;\n    border: black;\n    padding: 10px 15px;\n    border-radius: 30px;\n    cursor: pointer;\n  }\n\n  .uac-expandable-button {\n    margin-left: 30px;\n    background-color: none;\n    background: none;\n    border: black;\n    width: 170px;\n    font-size: 16px;\n    border-radius: 5px;\n    cursor: pointer;\n    transition: all 0.3s ease-in-out;\n    border: 1px solid black;\n  }\n  \n  .uac-expandable-button:hover {\n    width: 130px;\n    box-shadow: 0 0 5px green;\n  }\n\n  .uac-post-options {\n    position: relative;\n    display: inline-block;\n  }\n  \n  .uac-more-options-btn {\n    background: rgb(245, 238, 238);\n    margin-top: 20px;\n    margin-left: 170px;\n    width: 50px;\n    background: none;\n    border: none;\n    font-size: 20px;\n    cursor: pointer;\n  }\n  \n  .uac-dropdown-menu {\n    position: absolute;\n    margin-right: -150px;\n    top: 30px;\n    right: 0;\n    background: rgb(245, 238, 238);\n    border: 1px solid #ddd;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n    border-radius: 10px;\n    overflow: hidden;\n    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n    font-size: 18px;\n  }\n  \n  .uac-dropdown-menu button {\n    width: 100%;\n    padding: 10px;\n    border: none;\n    background: rgb(245, 238, 238);\n    cursor: pointer;\n    text-align: left;\n  }\n  \n  .uac-dropdown-menu button:hover {\n    background: #f0f0f0;\n  }\n\n  .uac-post-container {\n    width: 100%;\n    height: 100%;\n    border: 1px solid black;\n    border-radius: 8px;\n    background: none;    \n    overflow-y: auto;\n    padding: 30px;\n    background: var(--card-bg, rgb(4, 4, 4));\n    border: 1px solid var(--border-color, rgb(52, 51, 51));\n  }\n\n  .uacp-description-input {\n    margin-left: 0px;\n    height: 50%;\n    width: 100%;\n    padding: 10px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    resize: none;\n    overflow-y: auto;\n  }\n\n  .uac-submission-container {\n    height: auto;\n    width: 100%;\n    max-width: 1000px;\n    max-height: 60px;\n    padding: 15px;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    background:rgb(245, 238, 238);\n    /* box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1); */\n    overflow-y: auto;\n  }\n  \n  .uacp-media-section {\n    /* margin-top: 60px;\n    margin-bottom: 0px; */\n    width: 10%;\n    margin-left: 10px;\n    height: -10px;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    background: black;\n  }\n  \n  .uac-upload-btn, .uac-post-btn {\n    padding: 8px 12px;\n    margin-right: 5px;\n    width: 30px;\n    height: 30px;\n    font-size: 12px;\n    background: #007bff;\n    color: white;\n    border: none;\n    cursor: pointer;\n    border-radius: 5px;\n  }\n\n  .uacp-upload-btn {\n    padding: 8px 12px;\n    width: 150px;\n    height: 30px;\n    align-items: center;\n    font-family: puppins;\n    font-size: 15px;\n    color:white;\n    cursor: pointer;\n    border-radius: 10px;\n    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n    border: \"1px solid gray\";\n    margin-top: 10px;\n  }\n  \n  .uacp-post-btn {\n    padding: 8px 12px;\n    width: 100px;\n    height: 30px;\n    margin-top: 5px;\n    align-items: center;\n    font-family: puppins;\n    font-size: 15px;\n    margin-left: 20px;\n    color: white;\n    border: none;\n    cursor: pointer;\n    border-radius: 10px;\n    border: \"1px solid gray\";\n    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n    margin-top: 10px;\n  }\n  \n  .uac-uploaded-media {\n    margin-top: 10px;\n  }\n  \n  .uac-media-preview {\n    display: inline-block;\n    padding: 5px;\n    margin: 3px;\n    border-radius: 4px;\n  }\n  \n  .uac-tab-button {\n    padding: 10px 15px;\n    border: none;\n    color: black;\n    cursor: pointer;\n    transition: 0.3s;\n  }\n  \n  .uac-active-tab {\n    color: white !important;\n    cursor: default; /* Make it non-clickable */\n    font-weight: bold;\n  }\n\n  .uac-remove-btn {\n    padding: 8px 12px;\n    width: 65px;\n    height: 30px;\n    margin-top: 5px;\n    align-items: center;\n    font-family: puppins;\n    font-size: 12px;\n    margin-left: 20px;\n    color: white;\n    border: \"1px solid gray\";\n    cursor: pointer;\n    border-radius: 10px;\n    cursor: not-allowed; /* Show disabled cursor */\n    opacity: 0.6;\n    margin-top: 20px;\n  }\n  \n  .uac-remove-btn:not(:disabled) {\n    background-color: darkgray;\n    color: black;\n    cursor: pointer;\n    opacity: 1;\n  }\n\n  /* Main Feed */\n  .uac-main-feed {\n    width: 100%;\n    border-radius: 10px;\n    height: 100px;        /* Fixed height */\n    max-height: 1000vh;\n  }\n\n.uac-text-label {\n  font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;\n  font-size: 20px;\n  /* font-weight: lighter; */\n}\n\n/* ============================================================\n   USER ACCOUNT CREATE POST - METADATA SECTION\n   ============================================================ */\n\n   .uac-metadata-container {\n    margin-top: 10px;\n    display: flex;\n    align-items: center;\n    gap: 25px;\n    flex-wrap: wrap;\n    padding: 15px;\n    background: rgba(255, 255, 255, 0.05);\n    border-radius: 10px;\n    backdrop-filter: blur(8px);\n    -webkit-backdrop-filter: blur(8px);\n    border: 1px solid rgba(255, 255, 255, 0.1);\n  }\n  \n  .uac-visibility-section {\n    display: flex;\n    /* align-items: center; */\n    gap: 10px;\n  }\n  \n  .uac-metadata-label {\n    font-weight: 600;\n    color: rgba(255, 255, 255, 0.9);\n    font-size: 14px;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;\n  }\n  \n  .uac-visibility-status {\n    font-weight: bold;\n    font-size: 14px;\n    padding: 4px 12px;\n    border-radius: 12px;\n    background: rgba(0, 0, 0, 0.3);\n  }\n  \n  /* ============================================================\n     ID FIELDS (USER ID & PROFILE ID)\n     ============================================================ */\n  \n  .uac-id-field {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 8px 15px;\n    background: rgba(0, 0, 0, 0.3);\n    border-radius: 8px;\n    border: 1px solid rgba(255, 255, 255, 0.15);\n    transition: all 0.3s ease;\n    height: 45px;\n  }\n  \n  .uac-id-field:hover {\n    background: rgba(0, 0, 0, 0.4);\n    border-color: rgba(102, 126, 234, 0.5);\n  }\n  \n  .uac-id-value {\n    font-weight: 700;\n    color: rgba(255, 255, 255, 0.95);\n    font-size: 13px;\n    font-family: \"Courier New\", monospace;\n    padding: 4px 10px;\n    background: rgba(102, 126, 234, 0.2);\n    border-radius: 6px;\n    letter-spacing: 0.5px;\n  }\n  \n  /* User ID - Missing State */\n  .uac-id-missing {\n    background: rgba(239, 68, 68, 0.3);\n    color: rgba(239, 68, 68, 1);\n    font-style: italic;\n  }\n  \n  /* Profile ID - Optional State */\n  .uac-id-optional {\n    background: rgba(156, 163, 175, 0.2);\n    color: rgba(209, 213, 219, 1);\n  }\n  \n  /* ============================================================\n     DISABLED STATE FOR POST CREATION\n     ============================================================ */\n  \n  .uacp-description-input:disabled,\n  .uacp-upload-btn:disabled,\n  .uac-remove-btn:disabled,\n  .uacp-post-btn:disabled {\n    opacity: 0.4;\n    cursor: not-allowed;\n    filter: grayscale(70%);\n  }\n  \n  .uac-metadata-container input:disabled ~ .up-toggle-slider {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n  \n  /* ============================================================\n     RESPONSIVE DESIGN\n     ============================================================ */\n  \n  @media screen and (max-width: 768px) {\n    .uac-metadata-container {\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 15px;\n      margin-left: 0;\n      padding: 12px;\n    }\n  \n    .uac-visibility-section {\n      width: 100%;\n      justify-content: space-between;\n    }\n  \n    .uac-id-field {\n      width: 100%;\n      justify-content: space-between;\n    }\n  }\n  \n  @media screen and (max-width: 480px) {\n    .uac-metadata-label {\n      font-size: 12px;\n    }\n  \n    .uac-id-value {\n      font-size: 11px;\n      padding: 3px 8px;\n    }\n  \n    .uac-visibility-status {\n      font-size: 12px;\n      padding: 3px 10px;\n    }\n  }\n  \n  /* ============================================================\n     ACCESSIBILITY\n     ============================================================ */\n  \n  .uac-id-field:focus-within {\n    outline: 2px solid rgba(102, 126, 234, 0.6);\n    outline-offset: 2px;\n  }\n  \n  @media (prefers-contrast: high) {\n    .uac-id-field {\n      border-width: 2px;\n      border-color: currentColor;\n    }\n  \n    .uac-metadata-container {\n      border-width: 2px;\n    }\n  }\n  \n  @media (prefers-reduced-motion: reduce) {\n    .uac-id-field {\n      transition: none;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
